module.exports = __webpack_public_path__ + "static/media/checkIcon.3084fe63.svg";